module.exports = __webpack_public_path__ + "img/arrow-up-small-big.8ea740f0.svg";